import React from 'react'
import { Tooltip, Typography, makeStyles, Fade, IconButton } from '@material-ui/core'
import { InfoRounded } from '@material-ui/icons'

const useStyles = makeStyles({
  tooltip: {
    padding: '3px',
    fontSize: '13px'
  },
  infoIcon: {
    color: '#1e88e5'
  },
  infoIconBtn: {
    padding: '2px'
  }
})

const InfoIconAlongText = ({ infoText }) => {
  const classes = useStyles()
  return (
    <Tooltip
      arrow
      TransitionComponent={Fade}
      title={<Typography className={classes.tooltip}>{infoText}</Typography>}>
      <IconButton className={classes.infoIconBtn}>
        <InfoRounded className={classes.infoIcon} />
      </IconButton>
    </Tooltip>
  )
}

export default InfoIconAlongText
